import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const EXP_LOGO = 'https://customer-assets-lxgj4vgw.emergentagent.net/job_collective-hub-15/artifacts/5yj12ge8_eXp-Luxury-2Color-White-Horizontal.webp';

const NAV = [
  { label: 'The Collective', hash: 'collective' },
  { label: 'Portfolio', hash: 'portfolio' },
  { label: 'Luxury', hash: 'luxury' },
  { label: 'Private Clients', hash: 'private-clients' },
  { label: 'Legacy', hash: 'legacy' },
  { label: 'Connect', path: '/contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const jump = (item) => {
    setOpen(false);
    if (item.path) {
      navigate(item.path);
      return;
    }
    if (location.pathname === '/') {
      document.getElementById(item.hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate(`/#${item.hash}`);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? 'bg-[#0b0b0b]/85 backdrop-blur-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        {/* Left: eXp Luxury */}
        <Link to="/" className="flex items-center" aria-label="eXp Realty Luxury Home">
          <img src={EXP_LOGO} alt="eXp Realty Luxury" className="h-8 md:h-10 w-auto object-contain" />
        </Link>

        {/* Right: Desktop nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <button
              key={item.label}
              onClick={() => jump(item)}
              className="text-white text-[11px] tracking-[0.32em] uppercase hover:text-[#b39869] transition-colors duration-300"
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => setOpen(true)}
            aria-label="Open menu"
            className="text-white hover:text-[#b39869] transition-colors ml-2"
          >
            <Menu className="w-5 h-5" strokeWidth={1.2} />
          </button>
        </nav>

        {/* Mobile menu icon */}
        <button
          onClick={() => setOpen(true)}
          className="lg:hidden text-white"
          aria-label="Open menu"
        >
          <Menu className="w-6 h-6" strokeWidth={1.2} />
        </button>
      </div>

      {/* Side navigation drawer */}
      <div
        className={`fixed inset-0 z-[60] transition-opacity duration-500 ${
          open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-black/60"
          onClick={() => setOpen(false)}
          aria-hidden="true"
        />
        {/* Panel */}
        <aside
          className={`absolute top-0 right-0 h-full w-full sm:w-[420px] bg-[#0b0b0b] shadow-2xl transition-transform duration-500 ${
            open ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="flex items-center justify-between px-8 py-6 border-b border-white/10">
            <span
              className="text-white tracking-[0.35em] text-sm"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              MENU
            </span>
            <button
              onClick={() => setOpen(false)}
              aria-label="Close menu"
              className="text-white hover:text-[#b39869] transition-colors"
            >
              <X className="w-6 h-6" strokeWidth={1.2} />
            </button>
          </div>
          <nav className="flex flex-col px-8 py-10 gap-6">
            {NAV.map((item) => (
              <button
                key={item.label}
                onClick={() => jump(item)}
                className="text-left text-white text-xl md:text-2xl tracking-[0.25em] uppercase hover:text-[#b39869] transition-colors"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {item.label}
              </button>
            ))}
          </nav>
        </aside>
      </div>
    </header>
  );
}
